export const PRICE_LOCALE = "en-EN";
